export default "__VITE_ASSET__70a35170__"